import request from '@/utils/request'

function getInfo () {
  return request({
    url: '/pos/company',
    method: 'get'
  })
}

export default {
  getInfo
}
